import { Box, BoxProps, CardProps, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

export interface TableChipCellProps {
  /** cell header */
  header?: string;
  /** cell body */
  body: string;
  /** Additional MUI styling */
  cardProps?: CardProps;
  /** Additional header styling */
  headerProps?: BoxProps;
  /** chip props */
  chipProps?: BoxProps;
}

export const TableChipCell: PimoReactComponent<TableChipCellProps> = ({
  header,
  body,
  cardProps = {},
  chipProps = {},
  headerProps = {},
}) => {
  const theme = useTheme();
  return (
    <Box
      {...cardProps}
      sx={{ ...cardProps.sx, color: theme.palette.primary.contrastText }}
    >
      {header && (
        <Box {...headerProps} sx={{ ...headerProps.sx }}>
          {header}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "left",
          height: "2em",
        }}
      >
        <Box
          {...chipProps}
          sx={{
            textAlign: "center",
            py: "auto",
            px: "1em",
            borderRadius: "4px",
            ...chipProps.sx,
            fontWeight: 500,
            lineHeight: "2em",
            height: "2em",
          }}
        >
          {body}
        </Box>
      </Box>
    </Box>
  );
};

export default TableChipCell;
